import { useEffect, useState } from 'react';
import { FileUtils } from 'mw-style-react';

/**
 * Хук с кликом вне компонента
 */
const useDragFiles = ({ ref, callback }) => {
  const [dragActive, setDragActive] = useState(false);
  const dragEvents = ['dragenter', 'dragleave', 'dragover', 'drop'];

  async function selectFiles(filesSource) {
    // eslint-disable-next-line no-return-await
    return await FileUtils.makeFilesArr(filesSource);
  }

  const handleDragEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    switch (e.type) {
      case 'dragenter':
        setDragActive(true);
        break;
      case 'dragleave':
        setDragActive(false);
        break;
      case 'drop':
        setDragActive(false);
        selectFiles(e.dataTransfer.files).then((files) => callback(files));
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (ref.current) {
      dragEvents.forEach((e) => {
        ref.current.addEventListener(e, handleDragEvent, true);
      });
    }
    return () => {
      if (ref.current) {
        dragEvents.forEach((e) => {
          ref.current.removeEventListener(e, handleDragEvent);
        });
      }
    };
  }, [ref.current]);

  return { dragActive };
};

export default useDragFiles;
